import { UnknownError } from '@cian/peperrors';

import { TThunkAction } from '../../../types/redux/thunk';
import { ETelemetryEvents } from '../../../types/telemetry';
import { DEFAULT_ERROR_MESSAGE } from '../constants';
import { EFirstMessageResponseStatus, IAssertDependencies, TFirstMessageResponse } from '../types';

export const assertUnknownErrorStatus =
  (response: TFirstMessageResponse, { domain, telemetry }: IAssertDependencies): TThunkAction<void> =>
  (_dispatch, _getState, { logger }) => {
    if (response.status === EFirstMessageResponseStatus.UnknownError) {
      telemetry.increment(ETelemetryEvents.ChatFirstMessageSendUnknownError);

      const unknownError = new UnknownError({
        message: response.data.message || DEFAULT_ERROR_MESSAGE,
        domain,
      });

      logger.error(unknownError);
    }
  };
